import { React, CSSObject, Box, cx, styled } from '@common'
import { colors, media } from '@theme'
import { DeviceSize, DeviceSizes } from './types'


const ActiveBtn: CSSObject = {
    color: 'var(--bs-btn-active-color)',
    backgroundColor: 'var(--bs-btn-active-bg)',
    borderColor: 'var(--bs-btn-active-border-color)',
}
const InactiveBtn: CSSObject = {
    color: 'var(--bs-btn-color)',
    backgroundColor: 'var(--bs-btn-bg)',
    borderColor: 'var(--bs-btn-border-color)',
}

const Btn = styled.a({

    '.mobile &.mobile': ActiveBtn,
    '&.mobile': {
        [media.mobile]: {
            '.tablet &': InactiveBtn,
            '.desktop &': InactiveBtn,
            ...ActiveBtn
        },
    },

    '.tablet &.tablet': ActiveBtn,
    '&.tablet': {
        [media.tablet]: {
            '.mobile &': InactiveBtn,
            '.desktop &': InactiveBtn,
            ...ActiveBtn,
        }
    },

    '.desktop &.desktop': ActiveBtn,
    '&.desktop': {
        [media.desktop]: {
            '.mobile &': InactiveBtn,
            '.tablet &': InactiveBtn,
            ...ActiveBtn,
        },
    }
})


type SizeControlsProps = {
    className?: string
    setDisplay: (ev: React.MouseEvent<HTMLAnchorElement>) => void
    sizes?:  DeviceSize[]
}

export const SizeControls:FC<SizeControlsProps> = ({ className, setDisplay, sizes = DeviceSizes }) => {
    if (sizes.length == 1) return <></>

    return (
        <Box
            gridArea='cb'
            className={cx('screen-size-controls', className)}
            justify="end"
            gap
            align="center"
            margin={{ vertical: 'default' }}
            direction={{ mobile: 'column' }}
        >
            <i css={{ color: colors.lightText }}>View screen on </i>
            <div className="btn-group btn-group-sm">
                {sizes.map(s => <Btn href="#" key={s} data-size={s} onClick={setDisplay} className={cx('btn', 'btn-outline-primary', s)}>{s}</Btn>)}
            </div>
        </Box>

    )
}
